
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import { Cookies } from 'react-cookie';
import include from 'underscore.string/include'

const selectSeries = (pages, locale, series = ["serverless", "101", "2015"]) => {
    const sortedPages = sortBy(pages, 'data.date')
    // Posts are those with md extension that are not 404 pages OR have a date (meaning they're a react component post).
    const visiblePages = sortedPages
        .filter(page => (
            get(page, 'file.ext') === 'md' && !include(page.path, '/404') || get(page, 'data.date')
        ))

    // Select posts
    const selectedPages = visiblePages.reduce((pre, cur) => {
        if (!cur.data.draft && cur.data.lang === locale) {
            pre[cur.data.series] = pre[cur.data.series] || [];
            pre[cur.data.series].push(cur)
        }
        return pre;
    }, {})

    const usedSeries = Object.keys(selectedPages)

    return { series: usedSeries, pages: selectedPages }
}

const setCookie = () => {
    const cookie = new Cookies();
    const locale = cookie.get("locale") || browserLocale() || "en";

    if (cookie.get("locale") === undefined) {
        cookie.set("locale", locale)
    }
    return locale;
}


function browserLocale() {
    var lang

    if (navigator.languages && navigator.languages.length) {
        // latest versions of Chrome and Firefox set this correctly
        lang = navigator.languages[0]
    } else if (navigator.userLanguage) {
        // IE only
        lang = navigator.userLanguage
    } else {
        // latest versions of Chrome, Firefox, and Safari set this correctly
        lang = navigator.language
    }
    lang = lang.split("-")[0]
    console.log("lang : ", lang)

    if (lang = "zh") {
        lang = "cn"
    }
    return lang
}

export { selectSeries, setCookie };


// WEBPACK FOOTER //
// ./lib.js